<template>
  <div class="wrapper__mask">
    <si-mask-design
        v-show="current === 'design'"
        @changePage="toSubmission"
    ></si-mask-design>
    <si-mask-submission
        v-show="current === 'submission'"
        @changePage="current = 'design'"
        :mask="mask"
    ></si-mask-submission>
  </div>
</template>

<script>
    import MaskDesign from '@/components/MaskDesign.vue';
    import MaskSubmission from '@/components/MaskSubmission.vue';

    export default {

        name: 'MaskCreator',

        data() {

            return {
                current: 'design',
                mask: null
            };
        },

        methods: {

            toSubmission(image) {
                this.current = 'submission';
                this.mask = image;
            }
        },

        components: {
            SiMaskDesign: MaskDesign,
            SiMaskSubmission: MaskSubmission
        }
    }
</script>

<style scoped lang="scss">
    .wrapper__mask {
        height: 100%;
        width: 100%;
    }
</style>
